// extracted by mini-css-extract-plugin
export default {"form":"FormContainer_form__oS6wu"};